import { Injectable } from '@angular/core';
import { GetClientNameGQL } from '../../../generated/types';
import { map, take } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { CurrentOrganizationManagementImplService } from '../current-organization-management-impl.service';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  constructor(
    private getClientNameGQL: GetClientNameGQL,
    private title: Title
  ) {}

  updateManagerBridgeTitle(): void {
    const orgId = localStorage.getItem(
      CurrentOrganizationManagementImplService.CURRENT_ORG_ID_STORAGE_KEY
    );
    if (orgId) {
      this.getClientNameGQL
        .fetch(
          {
            orgId,
          },
          {
            fetchPolicy: 'cache-first',
            errorPolicy: 'all',
          }
        )
        .pipe(
          map((res) => {
            const data = res.data;
            let value = '';
            if (data && data.organization) {
              value = data.organization.name;
            }
            return value;
          }),
          take(1)
        )
        .subscribe((value) => this.title.setTitle(`${value}`));
    }
  }
}
